import UserwayIntegration from './UserwayIntegration';
export default UserwayIntegration;
